"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyTypesWhere = exports.propertyTypeReducer = exports.propertyTypeByIndex = exports.getPrimaryPropertyTypesForListingType = exports.getEquivalentPropertyTypes = exports.expandPropertyTypes = exports.default = exports.PropertyTypeKeys = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _listingType = _interopRequireWildcard(require("./listing-type"));
var _propertyTypeCategory = _interopRequireDefault(require("./property-type-category"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var NON_DEVELOPMENT_RESIDENTIAL = [_listingType.default.SALES_RESIDENTIAL.name, _listingType.default.RENTAL_RESIDENTIAL.name, _listingType.default.SHARE_RESIDENTIAL.name];
var PropertyTypeKeys = exports.PropertyTypeKeys = ['HOUSE', 'TOWNHOUSE', 'COTTAGE', 'UNIT', 'LAND', 'RURAL', 'APARTMENT', 'DUPLEX', 'COMMERCIAL_STUDIO', 'RELOCATABLE_HOME', 'VILLA', 'OTHER', 'INVESTMENT_PROPERTY', 'HOUSE_AND_LAND_PACKAGE', 'DUAL_OCCUPANCY', 'RETIREMENT_VILLAGE', 'CHALET', 'TRI_OCCUPANCY', 'COURTYARD_HOME', 'OFFICE', 'RETAIL', 'INDUSTRIAL', 'HOTEL', 'MOTEL', 'WAREHOUSE', 'OTHER_COMMERCIAL', 'COMMERCIAL_LAND', 'BUSINESS', 'RESIDENTIAL_WAREHOUSE', 'DEVELOPMENT', 'PROPERTY', 'UNKNOWN', 'OTHER'];
var PropertyTypeValues = {
  HOUSE: {
    index: 1,
    name: 'HOUSE',
    label: 'House',
    pluralLabel: 'Houses',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'house',
    metaDescription: 'a house',
    category: _propertyTypeCategory.default.HOUSE
  },
  TOWNHOUSE: {
    index: 2,
    name: 'TOWNHOUSE',
    label: 'Townhouse',
    pluralLabel: 'Townhouses',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    equivalents: [],
    urlSlug: 'townhouse',
    metaDescription: 'a townhouse',
    category: _propertyTypeCategory.default.TOWNHOUSE
  },
  COTTAGE: {
    index: 3,
    name: 'COTTAGE',
    label: 'Cottage',
    pluralLabel: 'Cottages',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a cottage',
    category: _propertyTypeCategory.default.HOUSE
  },
  UNIT: {
    index: 4,
    name: 'UNIT',
    label: 'Unit / Apartment',
    pluralLabel: 'Units / Apartments',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'unit-apartment',
    metaDescription: 'a unit / apartment',
    category: _propertyTypeCategory.default.UNIT
  },
  LAND: {
    index: 5,
    name: 'LAND',
    label: 'Land',
    pluralLabel: 'Land',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'land',
    metaDescription: 'land',
    category: _propertyTypeCategory.default.OTHER
  },
  RURAL: {
    index: 6,
    name: 'RURAL',
    label: 'Rural',
    pluralLabel: 'Rural',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'rural',
    metaDescription: 'a rural property',
    category: _propertyTypeCategory.default.OTHER
  },
  APARTMENT: {
    index: 7,
    name: 'APARTMENT',
    label: 'Apartment',
    pluralLabel: 'Apartments',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    equivalents: ['UNIT'],
    metaDescription: 'an apartment',
    category: _propertyTypeCategory.default.UNIT
  },
  DUPLEX: {
    index: 8,
    name: 'DUPLEX',
    label: 'Duplex',
    pluralLabel: 'Duplex',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'duplex',
    metaDescription: 'a duplex',
    category: _propertyTypeCategory.default.HOUSE
  },
  COMMERCIAL_STUDIO: {
    index: 9,
    name: 'COMMERCIAL_STUDIO',
    label: 'Studio',
    pluralLabel: 'Studios',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'studio',
    metaDescription: 'a studio',
    category: _propertyTypeCategory.default.OTHER
  },
  RELOCATABLE_HOME: {
    index: 10,
    name: 'RELOCATABLE_HOME',
    label: 'Relocatable Home',
    pluralLabel: 'Relocatable Homes',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['OTHER'],
    metaDescription: 'a relocatable home',
    category: _propertyTypeCategory.default.OTHER
  },
  VILLA: {
    index: 11,
    name: 'VILLA',
    label: 'Villa',
    pluralLabel: 'Villa',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a villa',
    category: _propertyTypeCategory.default.HOUSE
  },
  OTHER: {
    index: 12,
    name: 'OTHER',
    label: 'Other',
    pluralLabel: 'Other',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'other',
    metaDescription: 'a property',
    category: _propertyTypeCategory.default.OTHER
  },
  INVESTMENT_PROPERTY: {
    index: 13,
    name: 'INVESTMENT_PROPERTY',
    label: 'Investment Property',
    pluralLabel: 'Investment Properties',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'investment-property',
    metaDescription: 'an investment property',
    category: _propertyTypeCategory.default.OTHER
  },
  HOUSE_AND_LAND_PACKAGE: {
    index: 14,
    name: 'HOUSE_AND_LAND_PACKAGE',
    label: 'House and Land Package',
    pluralLabel: 'House and Land Packages',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'house-land',
    metaDescription: 'a house and land package',
    category: _propertyTypeCategory.default.OTHER
  },
  DUAL_OCCUPANCY: {
    index: 15,
    name: 'DUAL_OCCUPANCY',
    label: 'Dual Occupancy',
    pluralLabel: 'Dual Occupancy',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE', 'DUPLEX'],
    metaDescription: 'a dual occupancy',
    category: _propertyTypeCategory.default.OTHER
  },
  RETIREMENT_VILLAGE: {
    index: 16,
    name: 'RETIREMENT_VILLAGE',
    label: 'Retirement Village',
    pluralLabel: 'Retirement Village',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'retirement-village',
    metaDescription: 'a retirement village property',
    category: _propertyTypeCategory.default.OTHER
  },
  CHALET: {
    index: 17,
    name: 'CHALET',
    label: 'Chalet',
    pluralLabel: 'Chalet',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a chalet',
    category: _propertyTypeCategory.default.HOUSE
  },
  TRI_OCCUPANCY: {
    index: 18,
    name: 'TRI_OCCUPANCY',
    label: 'Tri Occupancy',
    pluralLabel: 'Tri Occupancy',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE', 'DUPLEX'],
    metaDescription: 'a tri occupancy',
    category: _propertyTypeCategory.default.OTHER
  },
  COURTYARD_HOME: {
    index: 19,
    name: 'COURTYARD_HOME',
    label: 'Courtyard Home',
    pluralLabel: 'Courtyard Home',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE'],
    metaDescription: 'a courtyard home',
    category: _propertyTypeCategory.default.TOWNHOUSE
  },
  OFFICE: {
    index: 20,
    name: 'OFFICE',
    label: 'Office',
    pluralLabel: 'Offices',
    icon: 'office',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'office',
    metaDescription: 'an office property',
    category: _propertyTypeCategory.default.OTHER
  },
  RETAIL: {
    index: 21,
    name: 'RETAIL',
    label: 'Retail',
    pluralLabel: 'Retail',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'retail',
    metaDescription: 'a retail property',
    category: _propertyTypeCategory.default.OTHER
  },
  INDUSTRIAL: {
    index: 22,
    name: 'INDUSTRIAL',
    label: 'Industrial',
    pluralLabel: 'Industrial',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'industrial',
    metaDescription: 'an industrial property',
    category: _propertyTypeCategory.default.OTHER
  },
  HOTEL: {
    index: 23,
    name: 'HOTEL',
    label: 'Hotel',
    pluralLabel: 'Hotels',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'hotel',
    metaDescription: 'a hotel property',
    category: _propertyTypeCategory.default.OTHER
  },
  MOTEL: {
    index: 24,
    name: 'MOTEL',
    label: 'Motel',
    pluralLabel: 'Motels',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'motel',
    metaDescription: 'a motel property',
    category: _propertyTypeCategory.default.OTHER
  },
  WAREHOUSE: {
    index: 25,
    name: 'WAREHOUSE',
    label: 'Warehouse',
    pluralLabel: 'Warehouses',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'warehouse',
    metaDescription: 'a warehouse property',
    category: _propertyTypeCategory.default.OTHER
  },
  OTHER_COMMERCIAL: {
    index: 26,
    name: 'OTHER_COMMERCIAL',
    label: 'Other Commercial',
    pluralLabel: 'Other Commercial',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'other-commercial',
    metaDescription: 'a commercial property',
    category: _propertyTypeCategory.default.OTHER
  },
  COMMERCIAL_LAND: {
    index: 27,
    name: 'COMMERCIAL_LAND',
    label: 'Commercial Land',
    pluralLabel: 'Commercial Land',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'commercial-land',
    metaDescription: 'a commercial property',
    category: _propertyTypeCategory.default.OTHER
  },
  BUSINESS: {
    index: 28,
    name: 'BUSINESS',
    label: 'Business',
    pluralLabel: 'Businesses',
    listingTypes: _listingType.CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'business',
    metaDescription: 'a commercial property',
    category: _propertyTypeCategory.default.OTHER
  },
  RESIDENTIAL_WAREHOUSE: {
    index: 29,
    name: 'RESIDENTIAL_WAREHOUSE',
    label: 'Residential Warehouse',
    pluralLabel: 'Residential Warehouses',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    equivalents: ['OTHER'],
    metaDescription: 'a residential warehouse',
    category: _propertyTypeCategory.default.OTHER
  },
  DEVELOPMENT: {
    index: 30,
    name: 'DEVELOPMENT',
    label: 'Apartment / Off the plan',
    pluralLabel: 'Apartments / Off the plan',
    listingTypes: [_listingType.default.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    alias: 'UNIT',
    urlSlug: 'development',
    metaDescription: 'an apartment / off the plan property',
    category: _propertyTypeCategory.default.OTHER
  },
  PROPERTY: {
    index: 31,
    name: 'PROPERTY',
    label: 'Property',
    pluralLabel: 'Properties',
    listingTypes: [_listingType.default.OFF_MARKET.name],
    equivalents: [],
    urlSlug: '',
    metaDescription: 'a property',
    category: _propertyTypeCategory.default.OTHER
  },
  UNKNOWN: {
    index: 32,
    name: 'UNKNOWN',
    label: 'Other',
    pluralLabel: 'Other',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['OTHER'],
    metaDescription: 'a property',
    category: _propertyTypeCategory.default.OTHER
  }
};
var PropertyType = PropertyTypeValues;
var propertyTypesWhere = exports.propertyTypesWhere = function propertyTypesWhere() {
  var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => true;
  return (0, _values.default)(PropertyType).filter(predicate);
};
var getEquivalentPropertyTypes = typeName => propertyTypesWhere(propertyType => propertyType.name === typeName || propertyType.equivalents.includes(typeName));
exports.getEquivalentPropertyTypes = getEquivalentPropertyTypes;
var propertyTypeByIndex = index => (0, _values.default)(PropertyType).find(propertyType => propertyType.index === index);
exports.propertyTypeByIndex = propertyTypeByIndex;
var getPrimaryPropertyTypesForListingType = listingTypeName => propertyTypesWhere(propertyType => (0, _isEmpty.default)(propertyType.equivalents) && propertyType.listingTypes.includes(listingTypeName));
exports.getPrimaryPropertyTypesForListingType = getPrimaryPropertyTypesForListingType;
var resolveAlias = propertyType => {
  var _PropertyType$propert, _PropertyType$propert2;
  return (_PropertyType$propert = (_PropertyType$propert2 = PropertyType[propertyType]) === null || _PropertyType$propert2 === void 0 ? void 0 : _PropertyType$propert2.alias) !== null && _PropertyType$propert !== void 0 ? _PropertyType$propert : propertyType;
};
var expandPropertyTypes = requestedTypes => (0, _flatten.default)(requestedTypes.map(requestedType => resolveAlias(requestedType)).map(requestedType => (0, _values.default)(PropertyType).filter(type => type.name === requestedType || (type.equivalents || []).includes(requestedType)).map(type => type.name)));
exports.expandPropertyTypes = expandPropertyTypes;
var propertyTypeReducer = requestedTypes => propertyType => expandPropertyTypes([propertyType]).find(typeName => requestedTypes.includes(typeName)) || 'OTHER';
exports.propertyTypeReducer = propertyTypeReducer;
var _default = exports.default = PropertyType;